import cx from 'classnames';

const createComponent = (
  strings: TemplateStringsArray,
  ...values: unknown[]
) => {
  const className = strings.reduce((result, string, i) => {
    return result + string + (values[i] || '');
  }, '');

  return ({
    children,
    as: Component = 'div',
    className: additionalClassName = '',
    ...props
  }: {
    children: React.ReactNode;
    className?: string;
    as?: React.ElementType;
    [key: string]: unknown;
  }) => (
    <Component
      className={cx(String(className).trim(), additionalClassName)}
      {...props}
    >
      {children}
    </Component>
  );
};

export default createComponent;
